import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishCtx = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try {
      const { data } = await api.get("/wishlist/ids");
      setIds(data);
    } catch { setIds([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = useCallback((pid) => ids.includes(pid), [ids]);

  const toggle = useCallback(async (pid) => {
    if (!user) return { needsAuth: true };
    if (ids.includes(pid)) {
      setIds((s) => s.filter((x) => x !== pid));
      await api.delete(`/wishlist/${pid}`);
    } else {
      setIds((s) => [...s, pid]);
      await api.post(`/wishlist/${pid}`);
    }
    return { ok: true };
  }, [ids, user]);

  const value = useMemo(
    () => ({ ids, has, toggle, refresh, count: ids.length }),
    [ids, has, toggle, refresh]
  );

  return <WishCtx.Provider value={value}>{children}</WishCtx.Provider>;
}

export const useWishlist = () => useContext(WishCtx);
